import { render, staticRenderFns } from "./BrandTreeRow.vue?vue&type=template&id=42f4c784&scoped=true"
import script from "./BrandTreeRow.vue?vue&type=script&lang=js"
export * from "./BrandTreeRow.vue?vue&type=script&lang=js"
import style0 from "./BrandTreeRow.vue?vue&type=style&index=0&id=42f4c784&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f4c784",
  null
  
)

export default component.exports